import { render, staticRenderFns } from "./CustomerChatView.vue?vue&type=template&id=3933b4cb&"
import script from "./CustomerChatView.vue?vue&type=script&lang=js&"
export * from "./CustomerChatView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports